import PassCover from 'icons/pass-cover'
import PassLogo from 'icons/pass-logo'
import { QRCodeCanvas } from 'qrcode.react'
import React from 'react'
import { invertTextColor, vcfText } from 'utils'
import { useFormikContext } from 'formik'
import { getImageURL } from 'utils'

function GooglePass({ design }) {
  const {
    backgroundColor,
    logoImage,
    stripImage,
    jobTitle,
    prefix,
    firstName,
    lastName,
    fullName,
    email,
    phone,
    phones,
    organisationName,
    companyURL,
    linkedInURL,
    socials,
    addresses,
    personalAccount,
  } = design


  const { values } = useFormikContext()
  let numbersOfStampPerLine = []
  let numberOfLines = []
  let imageSize = ''
  let totalStamps = 0

  if (values?.total_stamps) {
    totalStamps = parseInt(values.total_stamps, 10); // Renamed from length to totalStamps

    if (totalStamps <= 4) {
      imageSize = 50;
      numberOfLines = [1]; // Only 1 line for 1-4 stamps
      numbersOfStampPerLine = [totalStamps]; // All stamps in a single row
    }
    else if (totalStamps <= 6) {
      imageSize = 40;
      numberOfLines = [1, 1]; // 2 lines for 5-6 stamps
      numbersOfStampPerLine = [Math.min(totalStamps, 3), totalStamps - 3]; // 2 rows, split between them
    } else if (totalStamps == 7) {
      imageSize = 40;
      numberOfLines = [1, 1]; // 2 lines for 5-6 stamps
      numbersOfStampPerLine = [Math.min(totalStamps, 4), totalStamps - 4]; // 2 rows, split between them
    } else if (totalStamps == 8) {
      imageSize = 40;
      numberOfLines = [1, 1]; // 2 lines for 5-6 stamps
      numbersOfStampPerLine = [Math.min(totalStamps, 4), totalStamps - 4]; // 2 rows, split between them
    } else if (totalStamps <= 10) {
      imageSize = 40;
      numberOfLines = [1, 1]; // 2 lines for 7-10 stamps
      numbersOfStampPerLine = [Math.min(totalStamps, 5), totalStamps - 5]; // First row has 5, remaining in second
    } else if (totalStamps <= 12) {
      imageSize = 25;
      numberOfLines = [1, 1, 1]; // 3 lines for 11-15 stamps
      numbersOfStampPerLine = [
        Math.min(totalStamps, 4),
        Math.min(totalStamps - 4, 4),
        totalStamps - 8,
      ];
    } else if (totalStamps <= 15) {
      imageSize = 25;
      numberOfLines = [1, 1, 1]; // 3 lines for 11-15 stamps
      numbersOfStampPerLine = [
        Math.min(totalStamps, 5),
        Math.min(totalStamps - 5, 5),
        totalStamps - 10,
      ];
    } else if (totalStamps <= 18) {
      imageSize = 25;
      numberOfLines = [1, 1, 1]; // 3 lines for 11-15 stamps
      numbersOfStampPerLine = [
        Math.min(totalStamps, 6),
        Math.min(totalStamps - 6, 6),
        totalStamps - 12,
      ];
    } else if (totalStamps <= 21) {
      imageSize = 25;
      numberOfLines = [1, 1, 1]; // 3 lines for 16-20 stamps
      numbersOfStampPerLine = [
        Math.min(totalStamps, 7),
        Math.min(totalStamps - 7, 7),
        totalStamps - 14,
      ];
    } else if (totalStamps <= 24) {
      imageSize = 25;
      numberOfLines = [1, 1, 1]; // 3 lines for 16-20 stamps
      numbersOfStampPerLine = [
        Math.min(totalStamps, 8),
        Math.min(totalStamps - 8, 8),
        totalStamps - 16,
      ];
    } else if (totalStamps <= 27) {
      imageSize = 25;
      numberOfLines = [1, 1, 1]; // 3 lines for 16-20 stamps
      numbersOfStampPerLine = [
        Math.min(totalStamps, 9),
        Math.min(totalStamps - 9, 9),
        totalStamps - 18,
      ];
    } else if (totalStamps <= 30) {
      imageSize = 20;
      numberOfLines = [1, 1, 1]; // 3 lines for 21-30 stamps
      numbersOfStampPerLine = [
        Math.min(totalStamps, 10),
        Math.min(totalStamps - 10, 10),
        totalStamps - 20,
      ];
    }
  }

  return (
    <div className='tw-relative' style={{ maxWidth: '330px' }}>
      <div
        className='tw-visible tw-w-[330px] tw-shadow-lg tw-text-white tw-rounded-[32px] tw-overflow-hidden'
        style={{ backgroundColor: backgroundColor }}
      >
        <div className='tw-flex tw-flex-col tw-h-full tw-justify-between tw-pb-6 tw-w-full'>
          <div className='tw-relative tw-mt-[16px] tw-mr-[16px] tw-ml-[16px]'>
            <div className='tw-mb-[16px]'>
              <div className='tw-flex tw-flex-row tw-items-center'>
                <div className='tw-mr-[16px]'>
                  <div className='tw-rounded-full tw-w-[40px] tw-m-0 tw-flex'>
                    {logoImage ? (
                      <img
                        class='even:tw-hidden'
                        src={logoImage}
                        alt='Logo'
                      ></img>
                    ) : (
                      <div
                        id='default-logo'
                        className='tw-block tw-w-full tw-m-1'
                      >
                        <PassLogo color={invertTextColor(backgroundColor)} />
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    color: invertTextColor(backgroundColor),
                  }}
                ></div>
              </div>
              <div
                className='tw-text-[12px] tw-uppercase tw-mt-5'
                style={{
                  color: invertTextColor(backgroundColor),
                }}
              >
                {jobTitle}
              </div>
              {/* <div className='tw-flex tw-justify-between'>
                <p className='tw-text-1xl'>Customer Name:</p>
                <p>Points:</p>
              </div> */}
              <div
                className='tw-text-2xl tw-font-bold tw0 '
                style={{
                  color: invertTextColor(backgroundColor),
                }}
              >
                {fullName}
              </div>
              <div
                className=' tw-text-1xl tw-font-extralight'
                style={{
                  color: invertTextColor(backgroundColor),
                }}
              >
                <div className='tw-text-1xl'>{values?.designType == "stamps" ?  "Remaining Stamps" : "Reward Points" } </div>
                <div className='tw-text-1xl'> 0 </div>
              </div>
            </div>
            <div className='tw-mt-[12px] tw-mb-[12px]'>
              <div className='tw-bg-white tw-mt-5 tw-mx-auto tw-rounded-md tw-card-qrcode tw-max-w-fit tw-p-[16px] tw-rounded-[16px] tw-shadow-[0_4px_5px_0px_rgba(0,0,0,0.14)_0_1px_10px_0px_rgba(0,0,0,0.12)_0_2px_4px-1px_rgba(0,0,0,0.2)]'>
                <QRCodeCanvas
                  value={vcfText({
                    prefix,
                    firstName,
                    lastName,
                    email,
                    phone,
                    phones,
                    jobTitle,
                    organisationName,
                    companyURL,
                    linkedInURL,
                    socials,
                    addresses,
                    personalAccount,
                  })}
                  viewBox='0 0 53 53'
                  size={128}
                />
              </div>
              {/* <p
                className='tw-card-qrcode-text tw-text-base tw-mt-[8px] tw-font-normal tw-text-center'
                style={{
                  color: invertTextColor(backgroundColor),
                }}
              >
                Save my contact details
              </p> */}
            </div>
          </div>
        </div>
        {/* // <div className='tw-w-full tw-overflow-hidden tw-strip-preview tw-h-[170px]'>
        //   <img
        //     class='even:tw-hidden '
        //     src={stripImage}
        //     alt='Primary strip'
        //   ></img>
        // </div> */}
        {/* {stripImage ? ( */}
          <div className='tw-relative tw-h-[170px]'>
            <div className='tw-items-center tw-justify-center tw-h-[170px] tw-overflow-hidden tw-flex tw-aspect-[1033/407] tw-my-[15px]'>
              {stripImage && (
                <img
                  class='even:tw-hidden tw-w-full'
                  src={getImageURL(stripImage)}
                  alt='Primary strip'
                ></img>
              )}
            </div>
            {(values.designType == "stamps") && (
              <>
                <div className='tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-w-full'>
                  {numberOfLines.map((lineIndex, outerIndex) => (
                    <div
                      style={{
                        gridTemplateColumns: `repeat(${numbersOfStampPerLine[outerIndex]}, minmax(0, 1fr))`,
                      }}
                      className={`tw-grid tw-gap-2 tw-my-2 tw-w-11/12 tw-mx-auto tw-justify-center tw-items-center`}
                      key={outerIndex}
                    >
                      {[...Array(numbersOfStampPerLine[outerIndex])].map(
                        (_, innerIndex) => (
                          <div key={innerIndex}>
                            {lineIndex <= totalStamps && ( // Ensure only the selected number of stamps are displayed
                              <img
                                height={imageSize}
                                width={imageSize}
                                src={
                                  getImageURL(
                                    innerIndex === 0
                                      ? values.filled_image
                                      : values.unfilled_image
                                  ) || 'https://placehold.co/600x600'
                                }
                                alt={
                                  innerIndex === 0
                                    ? 'filledImage'
                                    : 'unfilledImage'
                                }
                                className='tw-mx-auto'
                              />
                            )}
                          </div>
                        )
                      )}
                    </div>
                  ))}
                </div>
              </>)}
          </div>
        {/* // ) : (
        //   <span
        //     id='default-strip'
        //     className='tw-flex tw-items-center tw-px-6 tw-w-full tw-aspect-[3/1]'
        //   >
        //     <div className='tw-mx-auto tw-w-2/3'>
        //       <PassCover color={invertTextColor(backgroundColor)} />
        //     </div>
        //   </span>
        // )} */}
      </div>
    </div>
  )
}

export default GooglePass
